import $ from 'jquery'
import { useEffect, useState } from 'react'

export const checkSessionIsFavourited = (favourites, eventId, sessionId) =>
  favourites.some(
    favourite => favourite.id === eventId && favourite.sessionIds && favourite.sessionIds.includes(sessionId)
  )

export const checkEventIsFavourited = (favourites, eventId) => favourites.some(favourite => favourite.id === eventId)

export const useFavourites = () => {
  const [favourites, setFavourites] = useState(window.getFavourites?.() || [])
  useEffect(() => {
    const handleFavouritesUpdated = () => setFavourites(window.getFavourites())
    $(document).on('favourites.updated', handleFavouritesUpdated)
    return () => {
      $(document).off('favourites.updated', handleFavouritesUpdated)
    }
  }, [])
  return favourites
}
